"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var types_1 = require("./types");
var Save = function (_a) {
    var _b = _a.attributes, formId = _b.formId, embedMode = _b.embedMode, seamlessEmbedCode = _b.seamlessEmbedCode, iframeEmbedCode = _b.iframeEmbedCode;
    var embedCode = '';
    switch (embedMode) {
        case types_1.EmbedMode.Seamless:
            embedCode = seamlessEmbedCode;
            break;
        case types_1.EmbedMode.IFrame:
            embedCode = iframeEmbedCode;
            break;
    }
    return (React.createElement("div", { className: "cog-wp-embed", "data-form": formId, dangerouslySetInnerHTML: { __html: embedCode } }));
};
exports.default = Save;
